import { MAP_COLOR_DPE_OLD } from "constants/index";

// Primary color of the /address/ page: antd theme (routes) + --address-primary CSS var (ai-map page)
export const ADDRESS_PRIMARY_COLOR = "#227270";

// DPE colors of the /address/ page: legacy palette with a denser D yellow
export const ADDRESS_MAP_COLOR_DPE: {
  [key: string]: string;
} = {
  ...MAP_COLOR_DPE_OLD,
  D: "#FFE44D",
};
